import React from 'react';
import { connect } from 'react-redux';
import { useDrag } from 'react-dnd';

let Field = ({ currentQuestion, questionType }) => {
  const [{ isDragging }, drag] = useDrag({
    item: { type: questionType.id },
    canDrag: !currentQuestion,
    collect: monitor => ({
      isDragging: !!monitor.isDragging()
    })
  });

  return (
    <div
      ref={drag}
      style={{
        cursor: 'move',
        backgroundColor: '#ffffff',
        border: '1px solid #DEDEDE',
        opacity: isDragging ? 0.1 : 1
      }}
      className="row align-items-center p-2 mb-2"
    >
      <div className="col text-center">
        <img width={20} height={20} src={questionType.icon} alt="Field Type Icon" />
      </div>
      <div className="col-9">
        <strong>{questionType.name}</strong>
        <p className="m-0">{questionType.description}</p>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    currentQuestion: state.questionLibrary.current
  }
}

Field = connect(mapStateToProps)(Field)

export default Field;